import { render, staticRenderFns } from "./MyStaffItem.vue?vue&type=template&id=1fbcb1c3"
import script from "./MyStaffItem.vue?vue&type=script&lang=js"
export * from "./MyStaffItem.vue?vue&type=script&lang=js"
import style0 from "./MyStaffItem.vue?vue&type=style&index=0&id=1fbcb1c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports